import { UserMenu } from 'moduleBase/types/Menu';

export const transformMenuBlockData = (userMenu: UserMenu, id: string) => {
  const findedBlock = userMenu.blocks.find((menuBlock) => menuBlock.id === id);

  return findedBlock;
};
